import React from "react";
import { Modal, ModalBody } from "reactstrap";
import Text from "components/Text";
import Button from "components/Button";
import { withTranslation } from "react-i18next";
import crossIcon from "../../../../assets/images/cross.svg";

const CancellationModal = ({ t, isModalOpen, closeModal, leaveDetail }) => {
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-lg modal-dialog-centered"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" lineHeight="25px" weight="500" color="#111B45">
          Reason
        </Text>
        <Text
          size="13px"
          weight="400"
          color="#79869A"
          marginTop="40px"
          lineHeight="14px"
        >
          {t("scheduler.rejectingActionTitle")}
        </Text>
        <Text
          size="14px"
          weight="600"
          lineHeight="20px"
          color="#102C42"
          marginTop="4px"
          break
        >
          {leaveDetail?.comment}
        </Text>
        <Button onClick={closeModal} className="mt-4">
          Close
        </Button>
      </ModalBody>
    </Modal>
  );
};
export default withTranslation()(CancellationModal);
